import { useTranslation } from 'react-i18next';
import useSWR from 'swr';

import { InfoCard, InfoCardRowDef } from '~components';

import PoliciesService from '../../services/policyService';

const service = new PoliciesService();

interface PolicyAdministrativeInfoCardProps {
	id?: string;
}

const PolicyAdministrativeInfoCard = ({ id }: PolicyAdministrativeInfoCardProps) => {
	const { t } = useTranslation();

	const { data, isLoading, error } = useSWR(id != null && [service.basePath, id], ([_, id]) =>
		service.getPolicyById(id)
	);

	const rows: InfoCardRowDef[] | undefined =
		data != null ?
			[
				{
					headerName: t('ui.label.commentRequired'),
					value: data.requireBookingComment,
					valueFormatter: (value: boolean) => t(value ? 'ui.enabled' : 'ui.disabled'),
				},
			]
		:	undefined;

	return (
		<InfoCard
			title={t('views.policyDetail.summary.cardHeaders.administrativePolicies')}
			rows={rows ?? []}
			error={error != null}
			loading={isLoading}
		/>
	);
};

export default PolicyAdministrativeInfoCard;
